import React from 'react';
import { BASEURL, fileExportUrl } from "@api/baseUrl"
import {Button, Drawer, message, Modal, Upload, Select, Form, Space} from "antd"
import { useRef, useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { columnsFn } from "./data"
import ProTable, { ActionType } from "@ant-design/pro-table"
import { checkGetCardOperatorList } from '@api/product';
import { productApi } from '@utils/util';
import {PROCODE_FACE_IMAGE_MATCH_CHECK, PROCODE_FACECOMPARE} from '@utils/enum';
import { ExportButton } from '@components/Common';
import ProForm, {ProFormText, ProFormSelect} from "@ant-design/pro-form";
import {faceImageMatch} from "@api/product/identityCheck";
import {ExclamationCircleOutlined} from "@ant-design/icons";

// 接口请求的 api 层
const getApi = productApi(checkGetCardOperatorList)

// 图片类型枚举
const IMAGE_TYPE = {
    BASE64: 'BASE64',
    URL: 'URL'
};

// 在线发送
export default () => {
    const history = useHistory()
    const formRef = useRef()
    const otherParams = { productCode: PROCODE_FACE_IMAGE_MATCH_CHECK }
    const dispatch = useDispatch()
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
    const [modalProps, setModalProps] = useState({ visible: false, title: '新增', params: {} })
    const ref = useRef<ActionType>(null);
    const operate = async (type: any, record: any) => {}

    const getListApi = async (params: any, sorter: any, filter: any) => {
        const { data } = await getApi({ ...params }, false)
        const { values, total } = data || {}
        return {
            data: values || [],
            success: true,
            total
        }
    }

    const columns = columnsFn(operate)
    const getQueryParams = () => ({
        // @ts-ignore
        ...formRef.current?.getFieldsFormatValue(),
        ...otherParams
    })

    const onSuccess = () => {
        console.log('处理后的成功回调触发了')
        reFresh()
    }

    const reFresh = () => {
        // @ts-ignore
        ref.current?.clearSelected()
        ref.current?.reload()
    }

    const [uploadVisible, setUploadVisible] = useState(false);

    // 图片类型选项
    const imageTypeOptions = [
        {
            label: (
                <Space>
                    <span>上传图片</span>
                </Space>
            ),
            value: IMAGE_TYPE.BASE64,
        },
        {
            label: (
                <Space>
                    <span>URL地址</span>
                </Space>
            ),
            value: IMAGE_TYPE.URL,
        }
    ];

    const OnlineRequest = ({ onOk }: { onOk?: () => void }) => {
        const [form] = ProForm.useForm();
        const [loading, setLoading] = useState(false);
        const [imageType, setImageType] = useState<string>(IMAGE_TYPE.BASE64);

        // BASE64模式的状态
        const [imageA, setImageA] = useState({
            base64: '',
            preview: '',
            fileName: '',
            fileSize: 0,
            fileType: ''
        });
        const [imageB, setImageB] = useState({
            base64: '',
            preview: '',
            fileName: '',
            fileSize: 0,
            fileType: ''
        });

        // URL模式的状态
        const [urlA, setUrlA] = useState('');
        const [urlB, setUrlB] = useState('');

        // 表单字段验证状态
        const [formValid, setFormValid] = useState({
            imageA: false,
            imageB: false
        });

        // 初始化表单，设置默认值
        useEffect(() => {
            form.setFieldsValue({
                imageType: IMAGE_TYPE.BASE64
            });
        }, [form]);

        // 将图片转换为 base64 并去掉头部
        const convertImageToBase64 = (file: File): Promise<string> => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const base64String = reader.result as string;
                    // 去掉 data:image/png;base64, 头部
                    const base64WithoutHeader = base64String.replace(/^data:image\/\w+;base64,/, '');
                    resolve(base64WithoutHeader);
                };
                reader.onerror = (error) => reject(error);
            });
        };

        // 验证图片文件
        const validateImageFile = (file: File) => {
            // 验证文件类型
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/gif', 'image/webp'];
            const isImage = validTypes.includes(file.type);
            if (!isImage) {
                message.error('只能上传 JPG、PNG、BMP、GIF、WEBP 格式的图片');
                return false;
            }

            // 验证文件大小 (限制1MB)
            const isLt5M = file.size / 1024 / 1024 < 1;
            if (!isLt5M) {
                message.error('图片大小不能超过1MB');
                return false;
            }

            // 验证文件名长度
            if (file.name.length > 100) {
                message.error('文件名过长，请重命名后上传');
                return false;
            }

            return true;
        };

        // 验证URL格式
        const validateImageUrl = (url: string): boolean => {
            const urlPattern = /^(http|https):\/\/[^\s$.?#].[^\s]*$/;
            const imageExtensionPattern = /\.(jpeg|jpg|png|bmp|gif|webp)(\?.*)?$/i;

            if (!urlPattern.test(url)) {
                return false;
            }

            console.log(1)
            if (!imageExtensionPattern.test(url)) {
                return false;
            }

            return true;
        };

        // 处理图片A上传
        const handleImageUploadA = async (file: File) => {
            try {
                // 验证文件
                if (!validateImageFile(file)) {
                    return false;
                }

                // 转换为 base64
                const base64String = await convertImageToBase64(file);

                // 生成预览图
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    setImageA({
                        base64: base64String,
                        preview: e.target?.result as string,
                        fileName: file.name,
                        fileSize: file.size,
                        fileType: file.type
                    });
                };

                // 设置表单值和验证状态
                form.setFieldsValue({ imageA: base64String });
                setFormValid(prev => ({ ...prev, imageA: true }));
                message.success('图片A上传成功');
                return false;
            } catch (error) {
                message.error('图片A上传失败');
                console.error('图片上传失败:', error);
                return false;
            }
        };

        // 处理图片B上传
        const handleImageUploadB = async (file: File) => {
            try {
                // 验证文件
                if (!validateImageFile(file)) {
                    return false;
                }

                // 转换为 base64
                const base64String = await convertImageToBase64(file);

                // 生成预览图
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    setImageB({
                        base64: base64String,
                        preview: e.target?.result as string,
                        fileName: file.name,
                        fileSize: file.size,
                        fileType: file.type
                    });
                };

                // 设置表单值和验证状态
                form.setFieldsValue({ imageB: base64String });
                setFormValid(prev => ({ ...prev, imageB: true }));
                message.success('图片B上传成功');
                return false;
            } catch (error) {
                message.error('图片B上传失败');
                console.error('图片上传失败:', error);
                return false;
            }
        };

        // 处理图片类型切换
        const handleImageTypeChange = (value: string) => {
            setImageType(value);

            // 重置所有状态
            form.resetFields(['imageA', 'imageB']);
            setImageA({ base64: '', preview: '', fileName: '', fileSize: 0, fileType: '' });
            setImageB({ base64: '', preview: '', fileName: '', fileSize: 0, fileType: '' });
            setUrlA('');
            setUrlB('');
            setFormValid({ imageA: false, imageB: false });

            // 重新设置图片类型
            form.setFieldsValue({ imageType: value });
        };

        // 处理URL A变化
        const handleUrlAChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            setUrlA(value);
            form.setFieldsValue({ imageA: value });

            // 验证URL格式
            if (value) {
                const isValid = validateImageUrl(value);
                setFormValid(prev => ({ ...prev, imageA: isValid }));
            } else {
                setFormValid(prev => ({ ...prev, imageA: false }));
            }
        };

        // 处理URL B变化
        const handleUrlBChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            setUrlB(value);
            form.setFieldsValue({ imageB: value });

            // 验证URL格式
            if (value) {
                const isValid = validateImageUrl(value);
                setFormValid(prev => ({ ...prev, imageB: isValid }));
            } else {
                setFormValid(prev => ({ ...prev, imageB: false }));
            }
        };

        // 检查表单是否有效
        const isFormValid = () => {
            if (imageType === IMAGE_TYPE.BASE64) {
                return formValid.imageA && formValid.imageB;
            } else {
                return formValid.imageA && formValid.imageB;
            }
        };

        // 获取文件大小格式
        const formatFileSize = (bytes: number) => {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        };

        // 移除图片
        const removeImageA = () => {
            setImageA({ base64: '', preview: '', fileName: '', fileSize: 0, fileType: '' });
            form.setFieldsValue({ imageA: undefined });
            setFormValid(prev => ({ ...prev, imageA: false }));
        };

        const removeImageB = () => {
            setImageB({ base64: '', preview: '', fileName: '', fileSize: 0, fileType: '' });
            form.setFieldsValue({ imageB: undefined });
            setFormValid(prev => ({ ...prev, imageB: false }));
        };

        // 表单提交处理
        const handleSubmit = async (values: any) => {
            try {
                // 验证表单
                if (!isFormValid()) {
                    if (imageType === IMAGE_TYPE.BASE64) {
                        message.error('请上传完整的图片信息');
                    } else {
                        message.error('请输入有效的URL地址');
                    }
                    throw new Error('表单验证失败');
                }
                if (loading) return;
                setLoading(true);
                let submitting = false;
                // 构建请求参数
                const params: any = {
                    imageType: imageType,
                };

                if (imageType === IMAGE_TYPE.BASE64) {
                    params.imageA = imageA.base64;
                    params.imageB = imageB.base64;
                } else {
                    params.imageA = urlA;
                    params.imageB = urlB;
                }

                Modal.confirm({
                    title: '确认要开始验证吗？',
                    icon: <ExclamationCircleOutlined />,
                    content: (
                        <div>
                            <div style={{ marginTop: 8, color: '#faad14' }}>
                                启动后将不支持取消，请确认！
                            </div>
                        </div>
                    ),
                    okButtonProps: {
                        loading,
                        disabled: loading,
                    },
                    onOk: async () => {
                        try {
                            if (submitting) return;
                            submitting = true;
                            await faceImageMatch(params);
                            message.success('提交成功，请稍后刷新页面查看调用结果');
                            // 重置表单
                            setTimeout(() => {
                                form.resetFields();
                                setImageA({ base64: '', preview: '', fileName: '', fileSize: 0, fileType: '' });
                                setImageB({ base64: '', preview: '', fileName: '', fileSize: 0, fileType: '' });
                                setUrlA('');
                                setUrlB('');
                                setImageType(IMAGE_TYPE.BASE64);
                                setFormValid({ imageA: false, imageB: false });
                                form.setFieldsValue({ imageType: IMAGE_TYPE.BASE64 });

                                // 触发成功回调
                                onOk?.();

                                // 延迟刷新表格
                                setTimeout(() => {
                                    reFresh();
                                }, 700);
                            }, 1000);
                        } catch (error: any) {
                            console.error('提交失败:', error);
                        } finally {
                            setTimeout(() => {setLoading(false);submitting=false}, 1000);
                        }
                    },
                    onCancel: () => {
                        submitting = false;
                        setLoading(false);
                    },
                });
            } catch (error: any) {
                console.error('表单验证或提交失败:', error);
            } finally {
                setTimeout(() => setLoading(false), 1000);
            }
        };

        // 自定义提交按钮
        const CustomSubmitter = () => (
            <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Button
                    type="primary"
                    size="large"
                    style={{ width: 200 }}
                    onClick={async () => {
                        try {
                            // 先验证必填字段
                            if (imageType === IMAGE_TYPE.BASE64) {
                                if (!imageA.base64 || !imageB.base64) {
                                    message.error('请上传两张图片');
                                    return;
                                }
                            } else {
                                if (!urlA || !urlB) {
                                    message.error('请填写两个URL地址');
                                    return;
                                }
                                if (!validateImageUrl(urlA) || !validateImageUrl(urlB)) {
                                    message.error('请填写有效的URL地址');
                                    return;
                                }
                            }

                            // 提交表单
                            const values = await form.validateFields();
                            await handleSubmit(values);
                        } catch (error) {
                            console.error('表单验证失败:', error);
                        }
                    }}
                    loading={loading}
                    disabled={!isFormValid()}
                >
                    开始验证
                </Button>
                <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
                    请确保所有信息填写完整
                </div>
            </div>
        );

        return (
            <div style={{ padding: '0 20px' }}>
                <ProForm
                    form={form}
                    layout="horizontal"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    submitter={{
                        render: () => <CustomSubmitter />
                    }}
                    onFinish={handleSubmit}
                    initialValues={{
                        imageType: IMAGE_TYPE.BASE64
                    }}
                >
                    {/* 图片类型选择 */}
                    <ProFormSelect
                        name="imageType"
                        label="请选择图片类型"
                        rules={[{ required: true, message: '请选择图片类型' }]}
                        placeholder="请选择图片类型"
                        options={imageTypeOptions}
                        fieldProps={{
                            onChange: handleImageTypeChange,
                            style: { width: '100%' }
                        }}
                    />

                    {imageType === IMAGE_TYPE.BASE64 ? (
                        <>
                            {/* 图片A上传 - BASE64模式 */}
                            <ProForm.Item
                                label="图片A"
                                name="imageA"
                                rules={[
                                    {
                                        required: true,
                                        message: '请上传图片A',
                                        validator: (_, value) => {
                                            if (!imageA.base64) {
                                                return Promise.reject('请上传图片A');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                                validateStatus={formValid.imageA ? 'success' : 'error'}
                                help={!formValid.imageA ? '请上传有效的图片文件' : ''}
                            >
                                <div style={{ marginBottom: 24 }}>
                                    <div style={{ marginBottom: 8 }}>
                                        <Upload
                                            accept=".jpg,.jpeg,.png,.bmp,.gif,.webp"
                                            showUploadList={false}
                                            beforeUpload={handleImageUploadA}
                                            customRequest={({ onSuccess }) => onSuccess?.('ok')}
                                        >
                                            <Button type="primary" ghost icon={<UploadOutlined />}>
                                                选择图片A
                                            </Button>
                                        </Upload>
                                        <span style={{ marginLeft: 12, fontSize: 12, color: '#999' }}>
                                            支持 JPG、PNG、BMP、GIF、WEBP 格式，最大 5MB
                                        </span>
                                    </div>

                                    {/* 图片A预览 */}
                                    {imageA.preview && (
                                        <div style={{
                                            marginTop: 12,
                                            padding: 12,
                                            border: '1px dashed #d9d9d9',
                                            borderRadius: 6,
                                            backgroundColor: '#fafafa'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <div>
                                                    <div style={{ fontWeight: 'bold', marginBottom: 4 }}>图片A预览</div>
                                                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                        文件名：{imageA.fileName}
                                                    </div>
                                                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                        文件大小：{formatFileSize(imageA.fileSize)}
                                                    </div>
                                                    <div style={{ fontSize: 12, color: '#666' }}>
                                                        Base64大小：{formatFileSize(imageA.base64.length)}
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <img
                                                        src={imageA.preview}
                                                        alt="图片A预览"
                                                        style={{
                                                            width: 120,
                                                            height: 120,
                                                            objectFit: 'contain',
                                                            border: '1px solid #f0f0f0',
                                                            borderRadius: 4
                                                        }}
                                                    />
                                                    <div style={{ marginTop: 8 }}>
                                                        <Button type="link" danger onClick={removeImageA} size="small">
                                                            移除
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </ProForm.Item>

                            {/* 图片B上传 - BASE64模式 */}
                            <ProForm.Item
                                label="图片B"
                                name="imageB"
                                rules={[
                                    {
                                        required: true,
                                        message: '请上传图片B',
                                        validator: (_, value) => {
                                            if (!imageB.base64) {
                                                return Promise.reject('请上传图片B');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                                validateStatus={formValid.imageB ? 'success' : 'error'}
                                help={!formValid.imageB ? '请上传有效的图片文件' : ''}
                            >
                                <div style={{ marginBottom: 24 }}>
                                    <div style={{ marginBottom: 8 }}>
                                        <Upload
                                            accept=".jpg,.jpeg,.png,.bmp,.gif,.webp"
                                            showUploadList={false}
                                            beforeUpload={handleImageUploadB}
                                            customRequest={({ onSuccess }) => onSuccess?.('ok')}
                                        >
                                            <Button type="primary" ghost icon={<UploadOutlined />}>
                                                选择图片B
                                            </Button>
                                        </Upload>
                                        <span style={{ marginLeft: 12, fontSize: 12, color: '#999' }}>
                                            支持 JPG、PNG、BMP、GIF、WEBP 格式，最大 5MB
                                        </span>
                                    </div>

                                    {/* 图片B预览 */}
                                    {imageB.preview && (
                                        <div style={{
                                            marginTop: 12,
                                            padding: 12,
                                            border: '1px dashed #d9d9d9',
                                            borderRadius: 6,
                                            backgroundColor: '#fafafa'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <div>
                                                    <div style={{ fontWeight: 'bold', marginBottom: 4 }}>图片B预览</div>
                                                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                        文件名：{imageB.fileName}
                                                    </div>
                                                    <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                        文件大小：{formatFileSize(imageB.fileSize)}
                                                    </div>
                                                    <div style={{ fontSize: 12, color: '#666' }}>
                                                        Base64大小：{formatFileSize(imageB.base64.length)}
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'center' }}>
                                                    <img
                                                        src={imageB.preview}
                                                        alt="图片B预览"
                                                        style={{
                                                            width: 120,
                                                            height: 120,
                                                            objectFit: 'contain',
                                                            border: '1px solid #f0f0f0',
                                                            borderRadius: 4
                                                        }}
                                                    />
                                                    <div style={{ marginTop: 8 }}>
                                                        <Button type="link" danger onClick={removeImageB} size="small">
                                                            移除
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </ProForm.Item>
                        </>
                    ) : (
                        <>
                            {/* URL模式 - 图片A输入 */}
                            <ProFormText
                                name="imageA"
                                label="图片A URL地址"
                                rules={[
                                    { required: true, message: '请输入图片A的URL地址' },
                                    {
                                        pattern: /^(http|https):\/\/[^\s$.?#].[^\s]*$/,
                                        message: '请输入有效的URL地址（必须以http://或https://开头）'
                                    },
                                    {
                                        validator: (_, value) => {
                                            if (value && !validateImageUrl(value)) {
                                                return Promise.reject('请输入有效的图片URL地址');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                                placeholder="请输入图片A的URL地址，如：https://example.com/image1.jpg"
                                fieldProps={{
                                    onChange: handleUrlAChange,
                                    style: { width: '100%' }
                                }}
                                validateStatus={urlA && !formValid.imageA ? 'error' : undefined}
                                help={urlA && !formValid.imageA ? '请输入有效的图片URL地址' : ''}
                            />

                            {/* URL模式 - 图片B输入 */}
                            <ProFormText
                                name="imageB"
                                label="图片B URL地址"
                                rules={[
                                    { required: true, message: '请输入图片B的URL地址' },
                                    {
                                        pattern: /^(http|https):\/\/[^\s$.?#].[^\s]*$/,
                                        message: '请输入有效的URL地址（必须以http://或https://开头）'
                                    },
                                    {
                                        validator: (_, value) => {
                                            if (value && !validateImageUrl(value)) {
                                                return Promise.reject('请输入有效的图片URL地址');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                                placeholder="请输入图片B的URL地址，如：https://example.com/image2.jpg"
                                fieldProps={{
                                    onChange: handleUrlBChange,
                                    style: { width: '100%' }
                                }}
                                validateStatus={urlB && !formValid.imageB ? 'error' : undefined}
                                help={urlB && !formValid.imageB ? '请输入有效的图片URL地址' : ''}
                            />

                            {/* URL预览区域 */}
                            {(urlA || urlB) && (
                                <ProForm.Item label="URL预览">
                                    <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
                                        {urlA && (
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>图片A</div>
                                                <div style={{
                                                    width: '100%',
                                                    height: 120,
                                                    border: '1px dashed #d9d9d9',
                                                    borderRadius: 4,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                            {urlA.length > 40 ? urlA.substring(0, 40) + '...' : urlA}
                                                        </div>
                                                        <div style={{ fontSize: 12, color: formValid.imageA ? '#52c41a' : '#ff4d4f' }}>
                                                            {formValid.imageA ? 'URL格式有效' : 'URL格式无效'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {urlB && (
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>图片B</div>
                                                <div style={{
                                                    width: '100%',
                                                    height: 120,
                                                    border: '1px dashed #d9d9d9',
                                                    borderRadius: 4,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                                            {urlB.length > 40 ? urlB.substring(0, 40) + '...' : urlB}
                                                        </div>
                                                        <div style={{ fontSize: 12, color: formValid.imageB ? '#52c41a' : '#ff4d4f' }}>
                                                            {formValid.imageB ? 'URL格式有效' : 'URL格式无效'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </ProForm.Item>
                            )}
                        </>
                    )}
                </ProForm>

                {/* 使用说明 */}
                <div style={{
                    marginTop: 24,
                    padding: 16,
                    border: '1px solid #e8e8e8',
                    borderRadius: 6,
                    backgroundColor: '#f9f9f9'
                }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 12, color: '#333' }}>
                        使用说明
                    </div>
                    <div style={{ fontSize: 13, lineHeight: 1.8, color: '#666' }}>
                        {imageType === IMAGE_TYPE.BASE64 ? (
                            <>
                                <div>📸 <strong>上传图片模式：</strong></div>
                                {/* eslint-disable-next-line react/no-unescaped-entities */}
                                <div>1. 点击"选择图片A"和"选择图片B"按钮上传两张需要比对的图片</div>
                                <div>2. 支持 JPG、PNG、BMP、GIF、WEBP 格式的图片文件</div>
                                <div>3. 单张图片大小不能超过 1MB</div>
                                <div>4. 图片将自动转换为Base64编码并去除头部信息</div>
                                <div>5. 上传后可预览图片信息，可随时移除重新上传</div>
                            </>
                        ) : (
                            <>
                                <div>🔗 <strong>URL链接模式：</strong></div>
                                <div>1. 输入两张图片的完整URL地址（必须以http://或https://开头）</div>
                                <div>2. URL地址应直接指向图片文件，而不是网页链接</div>
                                <div>3. 建议使用图片扩展名（如 .jpg、.png 等）的URL</div>
                                <div>4. 系统将直接从URL地址下载图片进行比对</div>
                                <div>5. 请确保URL地址可公开访问，无权限限制</div>
                            </>
                        )}
                        <div style={{ marginTop: 12 }}>
                            ⚠️ <strong>注意事项：</strong>
                        </div>
                        <div>• 请确保两张图片内容相关，系统将进行人脸或图像匹配度分析</div>
                        <div>• 提交成功后，系统将自动刷新列表显示比对结果</div>
                        <div>• 可在表格中查看历史记录并导出结果</div>
                        <div>• 该调用会产生一定费用,请确认余额充足</div>
                    </div>
                </div>

                {/* 底部提示 */}
                <div style={{
                    marginTop: 16,
                    padding: 12,
                    border: '1px dashed #91d5ff',
                    borderRadius: 6,
                    backgroundColor: '#e6f7ff'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', color: '#1890ff' }}>
                        <span style={{ marginRight: 8 }}>💡</span>
                        <span style={{ fontSize: 13 }}>
                            {imageType === IMAGE_TYPE.BASE64
                                ? '推荐上传清晰、光线良好的人脸正面照片以获得最佳匹配效果'
                                : '请确保URL地址稳定可访问，避免比对过程中图片无法加载'
                            }
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <ProTable<any>
                style={{ flex: 1, overflow: 'scroll' }}
                scroll={{ x: 1300 }}
                columns={columns}
                params={otherParams}
                request={getListApi}
                formRef={formRef as any}
                options={{ reload: false, density: false, setting: false }}
                toolbar={{
                    actions: [
                        <ExportButton
                            key="export"
                            type='primary'
                            action={`${BASEURL}/web/product/exportCardOperatorList`}
                            param={getQueryParams}
                            btnText="导出"
                        />,
                        <Button
                            key="online"
                            type="primary"
                            onClick={() => setUploadVisible(true)}
                            style={{ marginLeft: 8 }}
                        >
                            <Space>
                                <span>在线验证</span>
                            </Space>
                        </Button>,
                    ],
                }}
                rowKey="tiId"
                pagination={{ defaultPageSize: 10, showSizeChanger: true, showQuickJumper: true }}
                actionRef={ref as any}
                search={{
                    optionRender: (searchConfig, formProps, dom) => [...dom.reverse()]
                }}
            />
            <Drawer
                title={
                    <Space>
                        <span style={{ fontSize: 16, fontWeight: 'bold' }}>图片比对验证</span>
                    </Space>
                }
                open={uploadVisible}
                width={800}
                onClose={() => {
                    setUploadVisible(false);
                }}
                destroyOnClose
            >
                <OnlineRequest
                    onOk={() => {
                        setUploadVisible(false);
                        setTimeout(() => {
                            reFresh();
                        }, 1000);
                    }}
                />
            </Drawer>
        </>
    )
}

// 需要添加的图标组件
const UploadOutlined = () => (
    <svg viewBox="64 64 896 896" focusable="false" data-icon="upload" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"></path>
    </svg>
);